import { Component, Input, forwardRef, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CreateBookingService } from 'src/app/bookings/create-booking/create-booking.service';

@Component({
    selector: 'app-number-input',
    templateUrl: './number-input.component.html',
    styleUrls: ['./number-input.component.scss', '../../styles/form-input.scss'],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NumberInputComponent),
        multi: true
      }
    ]
})

export class NumberInputComponent extends BaseControlValueAccessor<number> implements OnInit {

  @Input() formControl: FormControl;
  @Input() config: any;
  @Input() label: string;
  @Output() changeCallback = new EventEmitter();
  @Input() multiday: boolean;

  private maxValue: number;
  value = 1;
  lessThan1 = true;

  constructor(private createBookingService: CreateBookingService){
    super();
  }
  ngOnInit() {

    if (this.formControl?.value > 1)
    {
      this.lessThan1 = false;
    }

    if (!this.multiday){
      setTimeout(() => {
        this.value = Number(this.formControl.value);
        this.inputChange();
        if (this.config && this.config.values && this.config.values.length) {
          this.maxValue = Number(this.config.values[0]);
        }
        if (this.maxValue === 1) {
          this.formControl.disable();
        }
      }, 0);
     }
     else {
      this.createBookingService.daysCount.subscribe(res => {
        this.value = res;
        if (this.value > 1) { this.lessThan1 = false; }
      });
     }

  }

  inputChange(): void {
    if (this.value > this.maxValue) {
      this.value = this.maxValue;
    } else if (this.value !== null) {
      this.value = Math.floor(this.value);
    }
    this.onChange(this.value);
    if (this.changeCallback) {
      this.changeCallback.emit(this.value);
    }
  }

  increment = (): void => {
    if (this.maxValue && this.maxValue === this.value) {
      return;
    }
    this.value = this.value ? this.value + 1 : 1;
    if (this.value > 1) { this.lessThan1 = false; }
    this.inputChange();
  }

  decrement = (): void => {
    this.value = this.value && this.value > 1 ? this.value - 1 : 1;
    if (this.value == 1) { this.lessThan1 = true; }
    this.inputChange();
  }

  showError(): boolean {
    return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
  }
}
